import jsPDF from "jspdf";
import "jspdf-autotable";

import AuditSXLogo from "../../../assets/AuditSX-logo.png";

function findUserName(userNames, id) {
  const user = userNames.find((user) => user.user_id === id);
  return user ? user.userName : null;
}

export const diningAuditPDFReport = (diningRecords, userNames) => {
  const doc = new jsPDF({ orientation: "landscape" });

  const headingText = "AuditSX:\nDining Audit Report Summary";

  const addHeader = (doc, currentY) => {
    doc.addImage(AuditSXLogo, "PNG", 15, currentY, 54, 15);

    doc.setFontSize(13);
    doc.text(headingText, 200, currentY + 6);

    return currentY + 25;
  };

  let currentY = 20; // Initial Y position for the first record

  // Add the header for the first page
  currentY = addHeader(doc, currentY);

  doc.setFontSize(8);

  doc.autoTable({
    startY: currentY,
    head: [
      [
        "Audited By",
        "Date",
        "Facility",
        "Unit",
        "Audit Completed For",
        "Meal Observed",
        "Snack Audit",
        "Environment",
        "Setup",
        "Assistance",
        "Activities/Staffing",
        "Interruption/Pace",
      ],
    ],
    body: diningRecords.map((record) => [
      findUserName(userNames, record.auditedBy),
      new Date(record.createdAt).toLocaleString(),
      record.facility,
      record.unit,
      record.auditCompletedFor,
      record.mealObserved,
      `${(record.snackAudit.compliance.percentage * 100).toFixed(1)}%`,
      `${(record.diningAudit.environment.compliance.percentage * 100).toFixed(
        1
      )}%`,
      `${(record.diningAudit.setup.compliance.percentage * 100).toFixed(1)}%`,
      `${(record.diningAudit.assistance.compliance.percentage * 100).toFixed(
        1
      )}%`,
      `${(record.diningAudit.activities.compliance.percentage * 100).toFixed(
        1
      )}%`,
      `${(record.diningAudit.interruption.compliance.percentage * 100).toFixed(
        1
      )}%`,
    ]),
  });

  doc.save(`dining_audit_report_${new Date().toISOString()}.pdf`);
};
